// React
import React from 'react';
import { useTranslation } from 'react-i18next';

// Libs
import Flag from 'semantic-ui-react/dist/commonjs/elements/Flag';
import Menu from 'semantic-ui-react/dist/commonjs/collections/Menu';

// Components
import AuthAndRefreshComponent from '../auth/AuthAndRefresh.component';

// Types
type MenuComponentProps = {
    language: string;
    onTokenChange: (t: string) => void;
};

/**
 * Header menu component over all components
 *
 * @param props MenuComponentProps
 * @returns React.ReactElement
 */
export default function MenuComponent(props: MenuComponentProps): React.ReactElement {
    const { t, i18n } = useTranslation();

    function onLanguageChange(_: React.SyntheticEvent, opts: any) {
        i18n.changeLanguage(opts['data-lng'] === 'de-DE' ? 'en-GB' : 'de-DE');
    }

    return (
        <menu>
            <Menu>
                <Menu.Menu position="right">
                    <Menu.Item
                        icon={<Flag name={i18n.language === 'en-GB' ? 'de' : 'gb'} />}
                        onClick={onLanguageChange}
                        data-lng={i18n.language}
                        content={t(`meta.${i18n.language}`)}
                    />
                    <AuthAndRefreshComponent onTokenChange={props.onTokenChange} />
                </Menu.Menu>
            </Menu>
        </menu>
    );
}
